import React from "react";
import Pagination from "./pagination1";
import "./table.css";
import SortingIcons1 from "../../assets/icons/arrowup-down";
import moment from "moment";
import RightViewIcon from "../../assets/icons/rigth-view-icon";
import PillBadge from "../helper-components/pill-badge";
const StockDetailsTable = ({
  tableHeading,
  tableBodyData = [],
  paginationProps,
  filterData,
  setFilterData,
  label = "Invoice",
  menu = true,
  onClickItemFn = () => {},
}) => {
  function sortFn(item) {
    let direction = "ASC";
    if (
      filterData != null &&
      filterData?.sortBy === item &&
      filterData?.sortOrder === "ASC"
    ) {
      direction = "DESC";
    }
    setFilterData({ ...filterData, sortBy: item, sortOrder: direction });
  }

  return (
    <>
      <div
        style={{
          height: `100%`,
        }}
        className="flex flex-col justify-between  px-[24px]"
      >
        <div
          style={{
            height: `calc(100% - 50px)`,
          }}
          className="tab-container outline outline-[var(--list-table-border-color)] outline-1 border-radius"
        >
          <table className="w-full border-collapse mt-0">
            <thead className="sticky top-0 bg-[var(--list-table-heading-bg)] z-[10]">
              <tr className="relative h-[50px]">
                {tableHeading
                  ?.filter((heading) => heading?.enabled !== false)
                  ?.map((heading, index) => (
                    <th
                      style={{ minWidth: `${heading?.minWidth}px` }}
                      key={index}
                      className={`${"border-b border-[var(--list-table-border-color)] px-[8px]"} whitespace-nowrap text-[var(--list-table-heading-fg-color)]  text-[length:--list-table-heading-font-size] font-[var(--list-table-heading-font-weight)]`}
                    >
                      <div
                        className="flex items-center gap-2 w-full"
                        style={{
                          justifyContent:
                            heading?.alignment === "right"
                              ? "flex-end"
                              : heading?.alignment === "center"
                              ? "center"
                              : "flex-start",
                        }}
                      >
                        {heading?.label}
                        {heading?.display && (
                          <button onClick={() => sortFn(heading?.value)}>
                            {" "}
                            <SortingIcons1
                              inc={
                                filterData?.sortOrder === "ASC" &&
                                heading?.value === filterData?.sortBy
                                  ? "var(--list-table-heading-fg-color)"
                                  : "var(--list-table-heading-fg-op-50-color)"
                              }
                              dec={
                                filterData?.sortOrder === "DESC" &&
                                heading?.value === filterData?.sortBy
                                  ? "var(--list-table-heading-fg-color)"
                                  : "var(--list-table-heading-fg-op-50-color)"
                              }
                            />
                          </button>
                        )}
                      </div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody className="h-full">
              {tableBodyData?.length > 0 ? (
                <>
                  {tableBodyData?.map((rowData, rowIndex) => (
                    <tr
                      className={`hover:bg-[var(--list-table-row-hover-bg)] bg-[var(--list-table-row-bg)]  h-[50px] `}
                      key={rowIndex}
                    >
                      {tableHeading
                        ?.filter((heading) => heading?.enabled !== false)
                        ?.map((heading, index) => {
                          if (
                            heading?.value === "actions" ||
                            heading?.label === "Actions"
                          ) {
                            return (
                              menu && (
                                <td
                                  key={index}
                                  className="border-b border-[var(--list-table-border-color)] px-[8px] h-[50px] text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap cursor-pointer flex justify-center items-center"
                                >
                                  <button
                                    onClick={() => {
                                      onClickItemFn(rowData);
                                    }}
                                  >
                                    <RightViewIcon />
                                  </button>
                                </td>
                              )
                            );
                          } else {
                            return heading?.value ? (
                              <td
                                style={{
                                  minWidth: `${heading?.minWidth}px`,
                                  textAlign: `${heading?.alignment}`,
                                }}
                                key={index}
                                className="border-b border-[var(--list-table-border-color)] px-[8px] text-left text-[length:--list-table-row-font-size] font-[var(--list-table-row-font-weight)] text-[var(--list-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                              >
                                {heading?.value === "item_exp_date" ? (
                                  (() => {
                                    const expDate = moment(
                                      rowData[heading.value]
                                    );
                                    const today = moment();
                                    const monthsDiff = expDate.diff(
                                      today,
                                      "months",
                                      true
                                    );

                                    let bgColor =
                                      "bg-[var(--pill-badge-red-bg)]";
                                    if (expDate.isBefore(today, "day")) {
                                      bgColor = "bg-[var(--pill-badge-red-bg)]"; // expired
                                    } else if (monthsDiff <= 3) {
                                      bgColor =
                                        "bg-[var(--pill-badge-yellow-bg)]"; // about to expire
                                    } else {
                                      bgColor =
                                        "bg-[var(--pill-badge-green-bg)]"; // safe
                                    }

                                    return (
                                      <PillBadge
                                        text={
                                          expDate.isValid()
                                            ? expDate.format("MMMM D, YYYY") // 👈 LOWERCASE FORMAT
                                            : "--"
                                        }
                                        className={bgColor}
                                      />
                                    );
                                  })()
                                ) : heading.value === "stock_status" ? (
                                  <PillBadge
                                    text={rowData[heading.value]}
                                    className={`${
                                      rowData[heading.value] === "In Stock"
                                        ? "bg-[var(--pill-badge-green-bg)]"
                                        : rowData[heading.value] ===
                                          "Out Of Stock"
                                        ? "bg-[var(--pill-badge-red-bg)]"
                                        : "bg-[var(--pill-badge-yellow-bg)]"
                                    }`}
                                  />
                                ) : heading?.type === "date" ? (
                                  moment(rowData[heading.value]).format(
                                    "MMM D, YYYY"
                                  )
                                ) : heading.value === "transaction_type" ? (
                                  <PillBadge
                                    text={rowData[heading.value]}
                                    className={`${
                                      rowData[heading.value] === "Billing"
                                        ? "bg-[var(--pill-badge-orange-bg)]"
                                        : rowData[heading.value] ===
                                          "Sales Return"
                                        ? "bg-[var(--pill-badge-red-bg)]"
                                        : rowData[heading.value] ===
                                          "Purchase Invoice"
                                        ? "bg-[var(--pill-badge-yellow-bg)]"
                                        : rowData[heading.value] === "GRN"
                                        ? "bg-[var(--pill-badge-blue-bg)]"
                                        : rowData[heading.value] ===
                                          "Purchase Order"
                                        ? "bg-[var(--pill-badge-sky-bg)]"
                                        : rowData[heading.value] ===
                                          "Purchase Return"
                                        ? "bg-[var(--pill-badge-voilet-bg)]"
                                        : rowData[heading.value] ===
                                          "Purchase Credit"
                                        ? "bg-[var(--pill-badge-pink-bg)]"
                                        : rowData[heading.value] ===
                                          "Sales Delivery"
                                        ? "bg-[var(--pill-badge-sky-bg)]"
                                        : rowData[heading.value] ===
                                          "Sales Invoice"
                                        ? "bg-[var(--pill-badge-sky-bg)]"
                                        : rowData[heading.value] ===
                                          "Sales Credit"
                                        ? "bg-[var(--pill-badge-d-voilet-bg)]"
                                        : rowData[heading.value] === "Stock In"
                                        ? "bg-[var(--pill-badge-l-green-bg)]"
                                        : rowData[heading.value] === "Stock Out"
                                        ? "bg-[var(--pill-badge-orange-bg)]"
                                        : rowData[heading.value] === "In Store"
                                        ? "bg-[var(--pill-badge-grey-bg)]"
                                        : rowData[heading.value] ===
                                          "Transfer Request"
                                        ? "bg-[var(--pill-badge-d-grey-bg)]"
                                        : "bg-[var(--pill-badge-grey-bg)]"
                                    }`}
                                  />
                                ) : (
                                  rowData[heading.value] || "--"
                                )}
                              </td>
                            ) : null;
                          }
                        })}
                    </tr>
                  ))}
                  <tr style={{ height: "10rem" }}></tr>
                </>
              ) : (
                <tr
                  style={{
                    height: "20rem",
                  }}
                >
                  <td
                    colSpan={tableHeading.length + 1}
                    className="text-center text-primary"
                  >
                    No {label + "'s"} found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination paginationProps={paginationProps} />
      </div>
    </>
  );
};

export default StockDetailsTable;
